/**
 * Per-OS desktop-app download link. Returns the stable "latest" installer URL
 * for the current OS, or null when there's no build for it (Linux / mobile).
 * Used by the account menu to offer "Download desktop app" to web visitors.
 */
const UPDATES_ORIGIN = "https://updates.lexicanon.com"

export function desktopDownloadUrl(): string | null {
  if (typeof navigator === "undefined") return null
  const ua = navigator.userAgent
  // Phones/tablets have no desktop build (and iPhone UAs contain "Mac OS X").
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return null
  if (/Macintosh/i.test(ua)) return `${UPDATES_ORIGIN}/api/desktop/download/latest/mac`
  if (/Windows/i.test(ua)) return `${UPDATES_ORIGIN}/api/desktop/download/latest/windows`
  return null
}
